import Loading from "components/ui/loading";

export default function LoadingGuide() {
  return <Loading />;
}
